import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

import { Error } from '@rpe/registro-personas-empresas-lib';
import { Laboratorio } from './laboratorios.model';

export const entityLaboratoriosAdapter: EntityAdapter<Laboratorio> =
  createEntityAdapter<Laboratorio>({
    selectId: (model) => model.id,
    sortComparer: (a: Laboratorio, b: Laboratorio): number =>
      b.id.toString().localeCompare(a.id.toString())
  });

export interface EntityLaboratoriosState extends EntityState<Laboratorio> {
  isLoading?: boolean;
  hasAddedSuccess?: boolean;
  error?: Error | null;
}

export const initialState: EntityLaboratoriosState =
  entityLaboratoriosAdapter.getInitialState({
    hasAddedSuccess: false,
    isLoading: false,
    error: null
  });
